import { render, staticRenderFns } from "./usertext.vue?vue&type=template&id=4deae825&scoped=true"
import script from "./usertext.vue?vue&type=script&lang=js"
export * from "./usertext.vue?vue&type=script&lang=js"
import style0 from "./usertext.vue?vue&type=style&index=0&id=4deae825&prod&lang=scss"
import style1 from "./usertext.vue?vue&type=style&index=1&id=4deae825&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4deae825",
  null
  
)

export default component.exports